import React from 'react';

const FreeLimitModal = ({ onClose, onUpgrade }) => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'var(--overlay)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            fontFamily: 'var(--body)',
        }}>
            <div style={{
                backgroundColor: 'var(--surface)',
                padding: 'clamp(20px, 5vw, 30px)',
                borderRadius: 'var(--r-xl)',
                maxWidth: 'min(360px, calc(100vw - 40px))',
                width: '100%',
                textAlign: 'center',
                border: 'var(--border)',
                boxShadow: 'var(--sh-lg)',
                boxSizing: 'border-box',
            }}>
                <div style={{
                    width: '60px', height: '60px', margin: '0 auto 16px',
                    display: 'grid', placeItems: 'center',
                    border: 'var(--border)', borderRadius: 'var(--r-md)',
                    background: 'var(--pro)', color: 'var(--pro-ink)',
                    boxShadow: 'var(--sh-sm)',
                }}>
                    <svg width="27" height="27" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" />
                    </svg>
                </div>

                <h2 style={{
                    fontSize: '22px',
                    color: 'var(--text)',
                    margin: '0 0 12px 0',
                    fontWeight: 'bold'
                }}>
                    Free Version Access
                </h2>

                <p style={{
                    color: 'var(--text-soft)',
                    fontSize: '15px',
                    lineHeight: '1.6',
                    marginBottom: '24px'
                }}>
                    You are currently viewing the <strong style={{ color: 'var(--text)' }}>top 150</strong> most frequent characters.
                    <br /><br />
                    Upgrade to Pro to unlock the full deck of <strong style={{ color: 'var(--lime)' }}>1,000</strong> characters and master Chinese faster!
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <button
                        onClick={onUpgrade}
                        style={{
                            width: '100%',
                            padding: '14px',
                            borderRadius: 'var(--r-md)',
                            border: 'var(--border)',
                            boxShadow: 'var(--sh)',
                            background: 'var(--pro)',
                            color: 'var(--pro-ink)',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                        }}
                    >
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 6l4.5 3.5L12 3l4.5 6.5L21 6l-1.8 12H4.8L3 6Z" /></svg>
                        Check Plans
                    </button>

                    <button
                        onClick={onClose}
                        style={{
                            width: '100%',
                            padding: '14px',
                            borderRadius: 'var(--r-md)',
                            border: 'var(--border)',
                            background: 'var(--surface-2)',
                            color: 'var(--text-soft)',
                            fontSize: '15px',
                            fontWeight: '500',
                            cursor: 'pointer',
                        }}
                    >
                        Got it, continue free
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FreeLimitModal;
